// extracted by mini-css-extract-plugin
export default {"home_main":"Home_home_main__wrZIN","model_container":"Home_model_container__wOey4"};